window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
}
catch (e) {
}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

$.ajax({
  type: 'GET',
  url: '/give-csrf',
  success: function (data) {
    if (data.success) {
      var input = $("<input>")
          .attr("type", "hidden")
          .attr("name", "_token").val(data.csrf);
      $('form').append($(input));
      $('meta[name="csrf-token"]').attr('content', data.csrf);


      window.Laravel = {
        csrfToken: data.csrf
      };

      window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf;

      $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': data.csrf
        }
      });

    }
  }
});
